import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Typography, Icons } from '@hmsexp/component-library';

const HeaderSortCell = ({ column, sortConfig, handleOnSortClick }) => {
  const [isPressed, setPressed] = useState(false);

  const isSortable = column?.sortable === true;

  const reduxDirection =
    sortConfig.field_name === column.field ? sortConfig.direction : null;

  const uiDirection =
    reduxDirection === 1 ? 'asc' : reduxDirection === -1 ? 'desc' : null;

  const toggleSort = () => {
    if (!isSortable) return;
    handleOnSortClick(column.field);
  };

  const justifyContent = isSortable ? 'flex-end' : 'flex-start';

  const borderStyle = isPressed
    ? { borderBottomWidth: 2, borderBottomColor: '#9bbbe8' }
    : uiDirection
    ? { borderBottomWidth: 2, borderBottomColor: '#2f78d0' }
    : { borderBottomWidth: 1, borderBottomColor: '#dde1e5' };

  const textColor = isSortable && uiDirection ? '#2F80ED' : '#1b2438';

  return (
    <TouchableOpacity
      disabled={!isSortable}
      onPress={toggleSort}
      onMouseEnter={() => isSortable && setPressed(true)}
      onMouseLeave={() => isSortable && setPressed(false)}
      style={{
        position: 'relative',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent,
        width: '100%',
        height: '100%',
        paddingHorizontal: 6,
        paddingVertical: 2,
        gap: 8,
        backgroundColor: column.field === 'total_count' ? '#E9F2FF' : '#fff',
        ...borderStyle
      }}>
      <Typography
        variant="body2"
        fontWeightType="semiBold"
        color={textColor}
        style={{
          flexShrink: 1,
          marginRight: isSortable ? 8 : 0
        }}
      >
        {column.label}
      </Typography>

      {isSortable && (
        <View style={{ justifyContent: 'center', alignItems: 'center' }}>

          <View style={{ transform: [{ scale: 0.65 }] }}>
            <Icons.ChevronUp
              size="XS"
              stroke={uiDirection === 'asc' ? '#2F80ED' : '#c6d1ec'}
            />
          </View>

          <View style={{ transform: [{ scale: 0.65 }] }}>
            <Icons.ChevronDown
              size="XS"
              stroke={uiDirection === 'desc' ? '#2F80ED' : '#c6d1ec'}
            />
          </View>
        </View>
      )}
    </TouchableOpacity>
  );
};

export default HeaderSortCell;

